// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"paragraph-module--paragraph--2sMfN","large":"paragraph-module--large--ctQQr","regular":"paragraph-module--regular--1L5wb"};